import { Component, Inject, LOCALE_ID } from '@angular/core';
import { Settings } from 'luxon';
import { RouterOutlet } from '@angular/router';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
	selector: 'trovata-angular-app',
	template: '<router-outlet></router-outlet>',
	styles: [],
	standalone: true,
	imports: [RouterOutlet],
})
export class AppComponent {
	constructor(
		@Inject(LOCALE_ID) public locale: string,
		private matIconRegistry: MatIconRegistry,
		private domSanitizer: DomSanitizer
	) {
		Settings.defaultLocale = this.locale;
		// Dynamically load Wijmo and set license key
		import('@grapecity/wijmo').then(wjcCore => {
			wjcCore.setLicenseKey(
				// eslint-disable-next-line max-len
				'dev.trovata.io|d2.trovata.io|jp-morgan.trovata.io|d3.trovata.io|d4.trovata.io|widget-dev.trovata.io|uat.trovata.io|wfuat-multibank.trvta.com|w1.trovata.io|beta.trovata.io|nab.trovata.io|small-business.trovata.io|dev.nab.trovata.io|d1.trovata.io|widget.trovata.io|wf-multibank.trvta.com|d5.trovata.io|app.trovata.io|d1.dev.citizens.trovata.io,588473142314533#B04awxybp9SY4FmdvJHduQDZs2WauEGdhZ7byRnLzQGLvlmLhRXY63mc49ibhdmcv5WLwpGLvlmLhRXY63mc49iMkxybp9SY4FmdvJHduYXZkJiOiMXbEJCLiMmbJBSY4FmdvJHViojIh94QiwiIzMTN4EzMyQTMzcDN8gTNiojIklkIs4XXbpjInxmZiwiIxYXNyAjMiojIyVmdiwSZzxWYmpjIyNHZisnOiwmbBJye0ICRiwiI34zdyYEcUhlbph6ZrNTdZlkMvFTdywUMyhkdwIUVuNEdtF4Tv3SczgTcNtyKwI4byMHdzVTS8MjZDl5Mu94aqJ6KuJWY8EGbiVmS7NDWWlFNwczVYZTVopmS6gURaRje6JTQIVWVIdmYGhGbERmWyVEMzQWSjNUQOZ5a5VXdxBFVycla4R6aMRXNQNGSLdUQrFHa8MmZERURrVkMoZTUvYGatVFOkNnaXpmWzMnV62mSm3GZNNEUZNHdysydSVFNyNncqZlamh7Z6NWbJllcoF5RQRGbLlmQwkDS7oXd7dDdhRjUz3GO5NmMyZTSWRlQNh6LjdjdFBnMxRGOxQHRUljRrc5L9gDUihTQwJzK95GO8ADNlRlQ5tSRvNGVCdHOykXcnN7YRZHTR9WQy84S9VWWygTdElXNrEDOONWUjBzNTtURMl7ZRlnUSRzNJ9GUZFTamNDR8tmI0IyUiwiIyEDN8QDRFJiOigkIsYzMyMDO4ETO0IicfJye#4Xfd5nIJBjMSJiOiMkIsIibvl6cuVGd8VEIgQXZlh6U8VGbGBybtpWaXJiOi8kI1xSfiUTSOFlI0IyQiwiIu3Waz9WZ4hXRgAicldXZpZFdy3GclJFIv5mapdlI0IiTisHL3JyS7gDSiojIDJCLi86bpNnblRHeFBCI73mUpRHb55EIv5mapdlI0IiTisHL3JCNGZDRiojIDJCLi86bpNnblRHeFBCIQFETPBCIv5mapdlI0IiTisHL3JyMDBjQiojIDJCLiUmcvNEIv5mapdlI0IiTisHL3JSV8cTQiojIDJCLi86bpNnblRHeFBCI4JXYoNEbhl6YuFmbpZEIv5mapdlI0IiTis7W0ICZyBlIsIyN4UTNwEDI4ETMwYjMwIjI0ICdyNkIsIybp9SY4FmdvJHduMnblpXa4l6YuYXZk9SMkxybp9SY4FmdvJHduAHchxybp9SY4FmdvJHduUDZs46bj9SY4Znc49yauFmYpRHb55WLmdHLvlmLhRXY63mc49CdldGZpdHLvlmLhRXY63mc49SMkxybp9SY4FmdvJHduIWYu9idlRGLvlmLhRXY63mc49yczVmbpNXdi5CbsFWbzxybp9SY4FmdvJHduIWYuxybp9SY4FmdvJHduEGdlJGLvlmLhRXY63mc49SM7xSbvNmLhRndyRnLr9WYilGdsVXbtQXY5Z6ds2WauEGdhZ7byRnL4FWds2WauEGdhZ7byRnL6VGZtQNZxR'
			);
		});
		this.matIconRegistry.addSvgIcon(
			'notifications-mark-as-unread',
			this.domSanitizer.bypassSecurityTrustResourceUrl('src/assets/svgs/notifications-mark-as-unread.svg')
		);
		this.matIconRegistry.addSvgIcon(
			'notifications-mark-as-read',
			this.domSanitizer.bypassSecurityTrustResourceUrl('src/assets/svgs/notifications-mark-as-read.svg')
		);
	}
}
